module.exports = __webpack_public_path__ + "static/media/member-emblem-green.94aaf5d8.png";